<template>
    <div @click="hidden" class="wxBottom">
        <div v-show="iranai" class="posi">
            <Button class="button button1" @click='toPath("/data/wxEntertain/"+WxCode,1)'>招待用餐</Button>
            <Button class="button button2" @click='toPath("/data/wxDinner/"+WxCode,2)'>个人用餐</Button>
<!--            <Button class="button button5" @click='toPath("/data/wxAddMeal/"+WxCode,5)'>个人加餐</Button>-->
            <div class="ivu-tooltip-arrow arrow"></div>
        </div>
        <Button class="button buttonA" @click.stop="isShow"><Icon type="coffee"></Icon>报餐</Button>
        <Button class="button button3" @click='toPath("/data/wxStatistics/"+WxCode,3)'><Icon type="ios-paper"></Icon>统计</Button>
        <Button class="button button4" @click='toPath("/data/wxList/"+WxCode,4)'><Icon type="android-walk"></Icon>活动</Button>
        <Button class="button button0" @click='toPath("/data/wxSend/"+WxCode,0)'><Icon type="person"></Icon>账号</Button>
        <!-- <Button v-for="(item,index) in bottomData" @click="toPath(item.path,index)"  :key="index" type="primary">{{item.value}}</Button> -->
        <Col v-show="isLoading == 'yes'" class="demo-spin-col" span="8">
            <Spin fix>
                <Icon type="load-c"  size="26" class="demo-spin-icon-load"></Icon>
                <div>加载中</div>
            </Spin>
        </Col>
    </div>
</template>


<script>
    import { mapState, mapGetters, mapMutations } from "vuex";
    export default {
        data () {
          return{
                WxCode:"",
                indexA:0,
                timer:{},
                iranai:false,
                bottomData:[
                    {
                        value:"账号",
                        path:"/data/wxSend/"+window.localStorage.getItem("wxCode")
                    },
                    {
                        value:"报餐",
                        path:"/data/wxDinner/"+window.localStorage.getItem("wxCode")
                    },
                    {
                        value:"统计",
                        path:"/data/wxStatistics/"+window.localStorage.getItem("wxCode")
                    },
//                     {
//                         value:"资产",
//                         path:"/data/wxProperty/"+window.localStorage.getItem("wxCode")
//                     },
                    {
                        value:"活动",
                        path:"/data/wxList/"+window.localStorage.getItem("wxCode")
                    },
                    {
                        value:"招待",
                        path:"/data/wxEntertain/"+window.localStorage.getItem("wxCode")
                    },
                    {
                        value:"招待列表",
                        path:"/data/wxEnterList/"+window.localStorage.getItem("wxCode")
                    }
                ]
            }
        },
        computed: {
		    ...mapState(["isLoading"]),
        },
        destroyed(){
            this.SET_LOADING("no");
        },
		watch:{
			"isLoading":function(e){
              console.log(e);
              if(e == "yes"){
					this.timer = setTimeout(()=>{
						if(e){
							alert("网络不稳定，请退出，在网络稳定的地方重新进入");
						}
					},10000)
				}else{
					window.clearTimeout(this.timer);
				}
			}
        },
        methods:{
            ...mapMutations(["SET_XCXID","SET_XCXUSER","SET_XCXREAL","SET_LOADING"]),
            toPath(e,i){
                var ele2 = document.getElementsByClassName("button");
                var ele3 = document.getElementsByClassName("button"+i);
                var ele4 = document.getElementsByClassName("buttonA");
                var ele = document.getElementsByTagName("title")[0];
                for(var j=0;j<ele2.length;j++){
                    ele2[j].classList.remove("toblue");
                }
                ele3[0].classList.add("toblue");
                if(i == 1 || i==2){
                    ele4[0].classList.add("toblue");
                }
                if(i == 0){
                	if(window.localStorage.getItem("isLogin")){
                    	ele.innerText = "账号解绑";
                	}else{
                    	ele.innerText = "账号绑定";
                	}
                }else if(i == 1){
                    ele.innerText = "招待用餐";
                }else if(i == 2){
                	ele.innerText = "个人用餐";
                }else if(i == 3){
                	ele.innerText = "统计";
                }else if(i == 4){
                	ele.innerText = "活动";
                }else if(i==5){
                  ele.innerText = "个人加餐"
                }
                this.$router.push(e);
            },
            hidden(){
                var ele = document.getElementsByClassName("posi")[0];
                ele.style.bottom = "-100px";
                ele.style.opacity = "0";
                this.indexA = 0;
            },
            isShow(){
                var ele = document.getElementsByClassName("posi")[0];
                if(this.indexA % 2 == 0){
                    ele.style.bottom = "60px";
                    ele.style.opacity = "1";
                    this.iranai = true;
                    this.indexA++;
                }else{
                    ele.style.bottom = "-100px";
                    this.iranai = false;
                    ele.style.opacity = "0";
                    this.indexA++;
                }
            }
        },
        mounted(){
        	if(this.$route.path.indexOf("wxSend") != -1){
        		document.getElementsByClassName("button0")[0].classList.add("toblue");
        	}else if(this.$route.path.indexOf("wxEntertain") != -1){
        		document.getElementsByClassName("button1")[0].classList.add("toblue");
        		document.getElementsByClassName("buttonA")[0].classList.add("toblue");
        	}else if(this.$route.path.indexOf("wxDinner") != -1){
        		document.getElementsByClassName("button2")[0].classList.add("toblue");
        		document.getElementsByClassName("buttonA")[0].classList.add("toblue");
        	}else if(this.$route.path.indexOf("wxStatistics") != -1){
        		document.getElementsByClassName("button3")[0].classList.add("toblue");
        	}else if(this.$route.path.indexOf("wxAddMeal") != -1){
        		document.getElementsByClassName("button5")[0].classList.add("toblue");
              document.getElementsByClassName("buttonA")[0].classList.add("toblue");
        	}
            this.WxCode = window.localStorage.getItem("wxCode");
        }
    }
</script>

<style lang="scss">
    .wxNoscroll{
        overflow: hidden;
    }
    .wxBottom{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        display: flex;
        height: 58px;
        .arrow{
		    left: 50%;
		    margin-left: -12px;
		    bottom: -10px;
		    border-width: 10px 11px 0;
		    border-top-color: #eee;
        }
        .demo-spin-icon-load{
            animation: ani-demo-spin 1s linear infinite;
            width: 40px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            ::before{
                height: 100%;
                width: 100%;
            }
        }
        @keyframes ani-demo-spin {
            from { transform: rotate(0deg);}
            50%  { transform: rotate(180deg);}
            to   { transform: rotate(360deg);}
        }
        .demo-spin-col{
            height: 100%;
            width: 100%;
            position: absolute;
            bottom: 0;
            height: 100vh;
            font-size: 26px;
        }
        >button{
            width: 25%;
            height: 100%;
            line-height: 35px;
            text-align: center;
            color: #807b7b;
            font-size: 4vw;
            border: 0;
            padding-top: 22px;
            border-radius: 0;
            background: #fff;
            >span{
                position: relative;
                >i{
                    position: absolute;
				    height: 26px;
				    width: 26px;
				    left: 50%;
				    top: -31px;
				    font-size: 20px;
				    margin-left: -13px;
                }
                >i:before{
                	content: "";
                	height: 100%;
                	width: 100%;
                	display: block;
                }
            }

        }
        >button:nth-child(2)>span>i:before{
        	background: url("../assets/nav_icon/d1.png") no-repeat;
            background-size: cover;
        }
        >button:nth-child(3)>span>i:before{
        	background: url("../assets/nav_icon/d2.png") no-repeat;
            background-size: cover;
        }
        >button:nth-child(4)>span>i:before{
        	background: url("../assets/nav_icon/d3.png") no-repeat;
            background-size: cover;
        }
        >button:nth-child(5)>span>i:before{
        	background: url("../assets/nav_icon/d4.png") no-repeat;
            background-size: cover;
        }
        .ivu-btn:hover{
            border: 0;
            box-shadow: 0 0 0 transparent;
            color:unset;
        }
        .toblue:nth-child(2)>span>i:before{
            background-image: url("../assets/nav_icon/b1.png");
        }
        .toblue:nth-child(3)>span>i:before{
            background-image: url("../assets/nav_icon/b2.png");
        }
        .toblue:nth-child(4)>span>i:before{
            background-image: url("../assets/nav_icon/b3.png");
        }
        .toblue:nth-child(5)>span>i:before{
            background-image: url("../assets/nav_icon/b4.png");
        }
        .toblue{
            color: #45aaf9 !important;
        }
        .posi{
            position: absolute;
            left: 0%;
            width: 25%;
            bottom: -100px;
            line-height: unset;
            transition: all .6 linear;
            opacity: 0;
            button{
                height: 40px;
                line-height: 32px;
                color: #807b7b;
                font-size: 4vw;
                background-color: #fff;
            }
            button:nth-child(1){
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
            button:nth-child(2){
                border-top-left-radius: 0;
                border-top-right-radius: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/wxNav.vue